import { i18n } from '@/plugins/i18n';

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('label.shareholder_name'),
        sortable: false,
        template: row => {
            return `<span>${row.first_name} ${row.last_name}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'user_name',
        title: i18n.t('label.user'),
        sortable: false,
        template: row => {
            return `<a target="_blank" href="/users/${row.user.id}/details">${row.user.name}</a>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
]
